import React from 'react';
import Modal from '../modal/Modal';
import AddTest from './AddTests';
import { Accordion, AccordionItem, AccordionItemTitle, AccordionItemBody } from 'react-accessible-accordion';
import {baseUrl} from '../url';
import moment from 'moment';

const Message = () => (
    <div style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
		padding: "10px",
		marginBottom: "-30px",
    }}>
        <p>No test results added yet.</p>
    </div>
)

class DisplayTests extends React.Component{
	state = {
		number: 1,
		tests: [],
	}
	componentDidMount(){
        this.fetchTests();
	}
	componentWillReceiveProps(nextProps){
		if (this.props.refresh === true){
			this.fetchTests();
		}
	}
	handleMonth = (number) => {
		this.setState({
			number,
		})
	}
    fetchTests = () => {
        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id');
        let retries = 0;
        fetch(`${baseUrl}/admin/patients/${user_id}/tests`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
				tests: responseJson.data
			});
			this.props.reset();
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
			}
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
	}

	render(){
		const { type } = this.props;
		const { number, tests } = this.state;
		const { afb, bloodcount, fastingbloodsugar, genexpert, lft, hiv } = tests;
		const e_u_cr = tests['e/u/cr'];
		return(
			<React.Fragment>
				{
					type === 'genexpert' &&
					<div className="test-item">
						{
							!genexpert && <Message/>
						}
						<div className="tab-buttons">
							{
								genexpert && genexpert.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								genexpert && genexpert.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>MTB Detected</h6>
											<p>{test.mtb === 1? 'Yes' : 'No'}</p>

											{
												test.rif &&
												<React.Fragment>
													<h6>RIF Resistance</h6>
													<p>Detected</p>
												</React.Fragment>
											}
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'bloodcount' &&
					<div className="test-item">
						{
							!bloodcount && <Message/>
						}
						<div className="tab-buttons">
							{
								bloodcount && bloodcount.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								bloodcount && bloodcount.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>Haemoglobin (Hb)</h6>
											<p>{test.haemoglobin}g/L</p>

											<h6>Haematocrit (PCV)</h6>
											<p>{test.haematocrit}L/L</p>

											<h6>WBC Total</h6>
											<p>{test.wbc_total}10<sup>9</sup>/L</p>

											<h6>Platelet</h6>
											<p>{test.platelet}10<sup>9</sup>/L</p>

											<h6>ESR</h6>
											<p>{test.esr}mm/hr</p>

											<h6>MCHC</h6>
											<p>{test.mchc}g/L</p>

											<h6>MCH</h6>
											<p>{test.mch}pg/Cell</p>

											<h6>MCV</h6>
											<p>{test.mcv}/fL</p>

											<h6>RBC</h6>
											<p>{test.rbc}10<sup>12</sup>/L</p>

											<h6>RDW</h6>
											<p>{test.rdw}%</p>

											<h6>PDW</h6>
											<p>{test.pdw}fl</p>

											<h6>Neutrophil (Poly)</h6>
											<p>{test.neutrophil}%</p>

											<h6>Lymphocytes</h6>
											<p>{test.lymphocytes}%</p>

											<h6>Mixed Field Differential</h6>
											<p>{test.mixed_field_differential}%</p>

											<h6>MPV</h6>
											<p>{test.mpv}/fL</p>

											<h6>P-LCR</h6>
											<p>{test.p_lcr}/%</p>

											<h6>MXD</h6>
											<p>{test.mxd}</p>

											<h6>Lymph#</h6>
											<p>{test.lymph}10<sup>3</sup>/uL</p>

											<h6>Mid#</h6>
											<p>{test.mid}10<sup>3</sup>/uL</p>

											<h6>Gran#</h6>
											<p>{test.gran}10<sup>3</sup>/uL</p>
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'afb' &&
					<div className="test-item">
						{
							!afb && <Message/>
						}
						<div className="tab-buttons">
							{
								afb && afb.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								afb && afb.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>Macroscopy</h6>
											<p>{test.macroscopy}</p>

											<h6>Result</h6>
											<p>{test.result}</p>

											{
												test.grading &&
												<React.Fragment>
													<h6>Grading</h6>
													<p>{test.grading}</p>
												</React.Fragment>
											}

											{
												test.actual_no &&
												<React.Fragment>
													<h6>Actual No</h6>
													<p>{test.actual_no}/100</p>
												</React.Fragment>
											}
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'lft' &&
					<div className="test-item">
						{
							!lft && <Message/>
						}
						<div className="tab-buttons">
							{
								lft && lft.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								lft && lft.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>AST</h6>
											<p>{test.ast} IU/L</p>

											<h6>ALT</h6>
											<p>{test.alt} IU/L</p>

											<h6>Alkaline Phosphate</h6>
											<p>{test.alk_phosphate} IU/L</p>

											<h6>Bilirubin (Total)</h6>
											<p>{test.bilirubin_total} IU/L</p>

											<h6>Total Protein</h6>
											<p>{test.total_protein} IU/L</p>

											<h6>Albumin</h6>
											<p>{test.albumin} IU/L</p>

											<h6>GGT</h6>
											<p>{test.ggt} IU/L</p>

											<h6>Bilirubin (Direct)</h6>
											<p>{test.bilirubin_direct} IU/L</p>
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'e_u_cr' &&
					<div className="test-item">
						{
							!e_u_cr && <Message/>
						}
						<div className="tab-buttons">
							{
								e_u_cr && e_u_cr.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								e_u_cr && e_u_cr.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>Serum Sodium</h6>
											<p>{test.serum_sodium}mmol/L</p>

											<h6>Potassium</h6>
											<p>{test.potassium}mmol/L</p>

											<h6>Chloride</h6>
											<p>{test.chloride}mmol/L</p>

											<h6>bicarbonates</h6>
											<p>{test.bicarbonates}mmol/L</p>

											<h6>Urea (BUN)</h6>
											<p>{test.urea_bun}mmol/L</p>

											<h6>Creatinine</h6>
											<p>{test.creatinine}mmol/L/24hrs</p>
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'fastingbloodsugar' &&
					<div className="test-item">
						{
							!fastingbloodsugar && <Message/>
						}
						<div className="tab-buttons">
							{
								fastingbloodsugar && fastingbloodsugar.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								fastingbloodsugar && fastingbloodsugar.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>Glucose</h6>
											<p>{test.glucose}mmol/L</p>

										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
				{
					type === 'hiv' &&
					<div className="test-item">
						{
							!hiv && <Message/>
						}
						<div className="tab-buttons">
							{
								hiv && hiv.map(test => {
									return (
										<div
											key={test.id}
											onClick={() => this.handleMonth(test.number)}
											className={number === test.number? 'active' : ''}>
											month {test.month}
										</div>
									)
								})
							}
						</div>
						<div className="test-results">
							{
								hiv && hiv.map(test => {
									return (
										number === test.number &&
										<React.Fragment key={test.id}>
											<h6>Date test was taken</h6>
											<p>{moment(test.treatment_date).format('DD/MM/YYYY')}</p>

											<h6>Result</h6>
											<p>{test.result}</p>

										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				}
			</React.Fragment>
		)
	}
}
class Tests extends React.Component{
  	constructor(){
		super()
		this.state = {
			show: false,
			refresh: false,
		}
	}
  	showModal = () => {
      	this.setState({ show: true });
  	};
  	hideModal = () => {
      	this.setState({ show: false });
	};
	refresh = () => {
		this.setState({refresh: true},
		()=>{
			this.props.checkTests();
		});
	}
	reset = () => {
		this.setState({refresh: false});
	}
    render() {
		const { refresh } = this.state;
        return (
          <div className="patient-tests">
            <div className="row">
                <div className="col-sm-6">
					<Accordion>
    				    <AccordionItem>
    				        <AccordionItemTitle>
								GeneXpert
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="genexpert" refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
    				    <AccordionItem>
    				        <AccordionItemTitle>
								AFB Smear Microscopy
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="afb" refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
						<AccordionItem>
    				        <AccordionItemTitle>
								HIV
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="hiv" refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
						<AccordionItem>
    				        <AccordionItemTitle>
								Fasting Blood Sugar
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="fastingbloodsugar" refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
    				</Accordion>
                </div>
                <div className="col-sm-6">
					<Accordion>
    				    <AccordionItem>
    				        <AccordionItemTitle>
								Liver Function Test (LFT)
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="lft"  refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
    				    <AccordionItem>
    				        <AccordionItemTitle>
								Kidney Function Test (E/U/Cr)
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="e_u_cr"	refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
						<AccordionItem>
    				        <AccordionItemTitle>
								Full Blood Count
    				        </AccordionItemTitle>

							<AccordionItemBody>
								<DisplayTests type="bloodcount" refresh={refresh} reset={this.reset}/>
    				        </AccordionItemBody>
    				    </AccordionItem>
    				</Accordion>
                </div>
            </div>
            <button onClick={this.showModal}><i className="fa fa-plus-circle"></i>Add test result</button>
            <Modal show={this.state.show} handleClose={this.hideModal}>
              {this.state.show && <AddTest handleClose={this.hideModal} refresh={this.refresh}/>}
            </Modal>
          </div>
        );
    }
}

export default Tests;



// WEBPACK FOOTER //
// ./src/components/patientProfile/Tests.js